<template>
  <ScrollContent :layout="true" class="clients__table">
    <Table
      v-if="clients"
      :columns="table_columns"
      :data="clients"
      :headings="headings"
      :sortable="sortable"
      :defaultSorting="'name'"
      :filterable="filterable"
      :columnsClasses="columnsClasses"
      :row-click="rowClick"
      placeholder="Данные клиента, товара или действия..."
    />
  </ScrollContent>
</template>

<script>
import data from "@/mockData/clientsTable.json";
import ScrollContent from "@/manzana_library/components/Elements/ScrollContent";
import { Table } from '@/manzana_library/components/Widgets/Table';

export default {
  name: 'Clients',
  components: {
    ScrollContent,
    Table
  },
  data() {
    return {
      table_columns: [
        "name",
        "phone",
        "cardNumber",
        "purchaseDate"
      ],
      headings: {
        name: "Имя клиента",
        phone: "Номер телефона",
        cardNumber: "Номер бонусной карты",
        purchaseDate: "Дата и время покупки"
      },
      sortable: [
        "name",
        "phone", 
        "cardNumber", 
        "purchaseDate"
      ],
      filterable: [
        "name",
        "phone", 
        "cardNumber", 
        "purchaseDate"
      ],
      columnsClasses: {
        // name: "bold left",
        // phone: "long",
        // cardNumber: "long",
        // purchaseDate: "nowrap"
      },
    }
  },
  computed: {
    clients() {
      return data.clients;
    }
  },
  methods: {
    rowClick(el) {
      this.$router.push({ path: `clients/${el.row.id}` });
    },
  }
};
</script>

<style lang="scss">
.clients__table {
  .VueTables {
    margin: 25px 23px;
    &__search {
      justify-content: start;
      margin-left: 9px;
    }
    &__table {
      border-top-color: transparent;
    }
  }
}
</style>